<div class="toptext">
  <h1>ReAdPQC25 - Recent Advances in Post-Quantum Cryptography 2025</h1>

  <h2>Organizing Committee</h2>
  <ul>
    <li>Marco Baldi (Marche Polytechnic University, Italy)</li>
    <li>Alessio Caminata (University of Genoa, Italy)</li>
    <li>Annamaria Iezzi (Université Grenoble Alpes, France)</li>
    <li>Alessio Meneghetti (University of Bari, Italy)</li>
    <li>Edoardo Persichetti (Florida Atlantic University, USA)</li>
    <li>Federico Pintore (University of Trento, Italy)</li>
  </ul>

  <h2>Description</h2>
  <p>
    Post-quantum cryptography — the study of cryptographic schemes capable of withstanding attackers equipped with both classical and quantum computers — is an area of research that has experienced tremendous growth in recent years, also due to the initiation of a standardization effort by NIST, which has led to the selection of the first schemes to standardise. More recently, the focus has been on post-quantum digital signature schemes, which are the subject of the latest NIST competition, and on the transition towards quantum-safe cryptography in real-world applications. This workshop will provide an overview of the state of the art of post-quantum cryptosystems and of the migration process towards them.
  </p>

  <h2>Call for Presentations</h2>
  <p>
    If you have a proposal for a talk, please send an abstract of maximum 2 pages to
    <a href="mailto:federico.pintore@unitn.it">federico.pintore<span>&#64;</span>unitn.it</a> and
    <a href="mailto:alessio.caminata@unige.it">alessio.caminata<span>&#64;</span>unige.it</a>.
    Submissions will be subject to a rolling review, i.e. abstracts will be evaluated as soon as the organising committee receives them.
    Proposals that will be deemed suitable for presentation at the workshop (by criteria of novelty, significance, and potential to spark discussion among the community) will be accepted within a short time frame (a few working days).
    The call will be closed once the time capacity of the workshop will be reached, or by the <b>10th of August</b> at the latest.
    Note that the rolling review process favours earlier submissions.
  </p>

  <h2>Important Dates</h2>
  <p>
    Abstract submission — From <b>July 15, 2025</b> to <b>August 10, 2025</b><br>
    ReAdPQC25 — <b>September 12, 2025</b>
  </p>

  <h2>Acknowledgements</h2>
  <p>
    This workshop is supported by project SERICS – Security and Rights in CyberSpace (PE00000014) under the MUR National Recovery and Resilience Plan, funded by the European Union – Next Generation EU.
  </p>

  <p align="center">
    <img src="https://i.ibb.co/fftcwgd/image.png" alt="image" border="0">
  </p>
</div>
